import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { CommentsModule } from '@helios/comments'
import { FilterModalModule } from '@helios/filter-modal'
import { GenericComponentsModule } from '@helios/generic-components'
import {
  NgbAlertModule,
  NgbDropdownModule,
  NgbTooltipModule,
} from '@ng-bootstrap/ng-bootstrap'
import { NgSelectModule } from '@ng-select/ng-select'
import { TableLayoutModule } from '@northfork/ag-grid-angular'
import { NfFormsModule } from '@northfork/ng-basics'
import { ExternalTransactionsGridComponent } from './external-transactions-grid.component'

@NgModule({
  imports: [
    CommonModule,
    // Angular Modules
    ReactiveFormsModule,
    FormsModule,

    // Third Party Modules
    NgSelectModule,
    NgbTooltipModule,
    NgbDropdownModule,

    // Northfork Modules
    NfFormsModule,
    TableLayoutModule,

    //Helios Modules
    GenericComponentsModule,
    FilterModalModule,
    NgbAlertModule,
    CommentsModule,
  ],
  declarations: [ExternalTransactionsGridComponent],
  exports: [ExternalTransactionsGridComponent, NgbDropdownModule],
})
export class ExternalTransactionsGridModule {}
